import { withNamespaces } from "react-i18next";
import React, { memo } from "react";
import { Col, Container, Row } from "reactstrap";
import "./style.scss";
import Tabs from "./tabs";
import { withRouter, useLocation } from "react-router-dom";
import PageBody from "../../../components/page-body";
import PageContent from "../../../components/page-content";
import Navigator from "src/components/Navigator";
import DataProtectionNewsList from "./tabs-content/latest-news";

const DataProtectionNews = (props) => {
  const location = useLocation();
  const { t } = props;

  const renderContent = () => {
    const searchParams = new URLSearchParams(location.search);

    let result = null;

    switch (searchParams.get("tab")) {
      case "latest-news":
        result = <DataProtectionNewsList/>;
        break;

      default:
        result = <DataProtectionNewsList/>;
        break;
    }

    return (
      <React.Fragment>
        <Tabs t={t} />

        {result}
      </React.Fragment>
    );
  };

  return (
    <PageContent classNames="data-protection-software-details-page software-details-page">
      <Container fluid>
        <Row>
          <Col lg="12" className="mb-4">
            <Navigator
              pageTitle="Latest News"
              breadCrumbs={[
                {
                  title: "SIP",
                  link: "/admin/data-protection/dashboard",
                },
                {
                  title: "Latest News",
                  link: `/admin/data-protection/latest-news?tab=latest-news`,
                },
              ]}
            />
          </Col>
        </Row>

        <PageBody classNames="p-0">
          <div className="details-content-wrapper">{renderContent()}</div>
        </PageBody>
      </Container>
    </PageContent>
  );
};

export default withNamespaces()(
  withRouter(memo(DataProtectionNews))
);
